import { Box, Card, Typography } from "@mui/material";

const DashBoardCards = ({ title, score, icon, bgColor, fontColor, borderLeft, onClick, statusKey }) => {
  return (
    <Box onClick={() => onClick?.(statusKey)} sx={{ cursor: "pointer" }} >
      <Card
        sx={{
          width: "100%",
          height: 75,
          color: "white",
          borderRadius: 3,
          boxShadow: "0px 4px 20px rgba(0,0,0,0.2)",
          p: 1.5,
          transition: "0.3s",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          ml: 1.8,
          background: bgColor,
          borderLeft: borderLeft,
          "&:hover": {
            transform: "scale(1.05)",
            boxShadow: "0px 6px 25px rgba(0,0,0,0.3)",
          },
        }}
      >
        {/* Title */}
        <Typography
          variant="subtitle2"
          sx={{
            opacity: 0.8,
            fontFamily: "Montserrat",
            fontWeight: "bold",
            fontSize: "14px",
            lineHeight: "100%",
            letterSpacing: 0,

          }}
        >
          {title}
        </Typography>

        {/* Score + Icon row */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            // px: 1,

          }}
        >
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ fontSize: "30px", color: fontColor }}
          >
            {score}
          </Typography>

          {/* <Box
            sx={{
              width: 45,
              height: 45,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.2)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              ml: 8,
            }}
          >
            <img src={icon} alt="icon" width="24" height="24" />
          </Box> */}
        </Box>
      </Card>
    </Box>
  );
};

export default DashBoardCards;
